<template>
    <Dialog :visible="dialogIsVisible" modal :header="paymentDone ? 'Reserva concluída' : 'Último passo'"
        :contentStyle="{ minWidth: '400px', minHeight: '300px' }" @update:visible="$emit('update:dialogIsVisible', false)">
        <div class="flex flex-col items-center text-center">
            <div v-if="!paymentDone">
                <table class="w-full text-base table-auto text-left mb-2">
                    <tbody>
                        <tr>
                            <td class="font-semibold pr-4">Valor da compra:</td>
                            <td>{{ formatCurrency(paymentPixValue) }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold pr-4">Expira em:</td>
                            <td>{{ timeToExpire }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="bg-gray-50 p-4 rounded-md">
                    <img :src="paymentPixImageBase64" alt="Código QR" class="w-36 h-36 object-contain mx-auto" />
                </div>

                <p class="font-bold mb-2">Aguardando pagamento</p>

                <Button @click="copyQrCode()" class="w-full" :label="copyQrCodeButtonText"
                    :disabled="copyQrCodeButtonDisabled"></Button>
            </div>

            <div v-else>
                <img class="w-[200px] mx-auto my-2" src="/img/illustration/done.svg" alt="Ilustração de sucesso">

                <p class="font-semibold my-2">Sua reserva está confirmada!</p>
                <p>Um comprovante foi enviado a seu e-mail.</p>

                <div class="my-2">
                    <Button @click="$emit('update:dialogIsVisible', false)" class="w-full" label="Finalizar" severity="primary" />
                </div>
            </div>
        </div>
    </Dialog>
</template>
<script>
import { Button, Dialog } from 'primevue';
import { formatDistanceStrict, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import PaymentService from '@/services/paymentService';

export default {
    name: 'DialogAgendaPayment',
    components: {
        Dialog,
        Button
    },
    props: {
        dialogIsVisible: Boolean,
        paymentPixValue: Number,
        paymentPixImageBase64: String,
        paymentPixCopyPaste: String,
        paymentPixExpirationAt: String,
        paymentPaymentId: Number,
        paymentAlreadyPaid: Boolean,
        lotePaymentEnabled: Boolean
    },
    emits: ['update:dialogIsVisible'],
    data() {
        return {
            // Used for force real time update
            timerId: null,
            now: new Date(),

            timerPaymentDone: null,

            copyQrCodeButtonDisabled: false,
            copyQrCodeButtonText: 'Copiar código PIX',

            redirectPath: this.$store.state.accessLevel == 'admin' ? '/admin' : '/user/agendas',
            paymentDone: false,
        }
    },
    methods: {
        async copyQrCode() {
            const text = this.paymentPixCopyPaste;

            // Clipboard API modern
            if (navigator.clipboard && window.isSecureContext) {
                try {
                    await navigator.clipboard.writeText(text);

                    this.copyQrCodeButtonText = 'Código copiado!';
                    this.copyQrCodeButtonDisabled = true;
                    return;
                } catch (err) {
                    console.error('Falha ao copiar o código PIX', err)
                }
            }

            // Old method, for browsers that do not support Clipboard API
            const textarea = document.createElement('textarea')
            textarea.value = text

            textarea.setAttribute('readonly', '')
            textarea.style.position = 'absolute'
            textarea.style.left = '-9999px'

            document.body.appendChild(textarea)
            textarea.select()

            try {
                document.execCommand('copy')

                this.copyQrCodeButtonText = 'Código copiado!';
                this.copyQrCodeButtonDisabled = true;
            } catch (err) {
                this.copyQrCodeButtonText = 'Falha ao copiar';
                this.copyQrCodeButtonDisabled = true;
            }

            document.body.removeChild(textarea)

            setTimeout(() => {
                this.copyQrCodeButtonText = 'Copiar código PIX';
                this.copyQrCodeButtonDisabled = false;
            }, 2500);
        },
        async checkIfPaymentDone() {
            try {
                if(this.paymentAlreadyPaid){
                    this.paymentDone = true;
                    clearInterval(this.timerPaymentDone);

                    return;
                }

                let paymentRequest;
                if(this.lotePaymentEnabled){
                    paymentRequest = await PaymentService.getTxidStatus(this.paymentPaymentId);
                } else {
                    paymentRequest = await PaymentService.getPayment(this.paymentPaymentId);
                }

                if (paymentRequest.status === 200) {
                    const data = paymentRequest.data;
                    
                    if (data.status == 'PAID') {
                        this.paymentDone = true;
                        clearInterval(this.timerPaymentDone);
                    }
                } else {
                    throw new Error(`Failed to get payment: ${paymentRequest.status}`);
                }
            } catch (error) {
                console.error('(checkIfPaymentDone) Falha ao verificar pagamento', error);
                this.sendToast("Falha de processamento", "Não conseguimos verificar se o pix foi pago. Efetue o pagamento normalmente e você poderá fechar está página.", "error");

                clearInterval(this.timerPaymentDone);
            }
        },
    },
    computed: {
        timeToExpire() {
            if (!this.paymentPixExpirationAt || !this.now) return '';

            const expiresAt = parseISO(this.paymentPixExpirationAt)

            return formatDistanceStrict(expiresAt, this.now, {
                locale: ptBR,
                unit: 'minute',
                roundingMethod: 'floor'
            });
        }
    },
    watch: {
        dialogIsVisible(opened) {
            if (opened) {
                this.timerId = setInterval(() => {
                    this.now = new Date();
                }, 60_000);

                this.timerPaymentDone = setInterval(async () => {
                    await this.checkIfPaymentDone();
                }, 4_000);
            } else {
                clearInterval(this.timerId);
                clearTimeout(this.timerPaymentDone);
            }
        },
        paymentAlreadyPaid(newValue) {
            if(newValue == true){
                this.paymentDone = true;
            }
        }
    }
    // TODO: Verificar necessidade e se for necessario, ajustar em todos setTimeout ou setInterval
    // beforeUnmount() {
    //     clearInterval(this.timerId);
    //     clearInterval(this.timerPaymentDone);
    // }
}
</script>

<style scoped></style>